module.exports = __webpack_public_path__ + "img/kayak_october.fa39e6ac.jpg";